export default "__VITE_ASSET__BFPuhTIF__"